<template>
  <div id="login">
    <!-- wurde komplett in Login Component ausgelagert -->
  </div>
</template>

<script>
export default {};
</script>
